var map = {
	"./1.png": "8e89",
	"./10.png": "caf1",
	"./2.png": "db1a",
	"./3.png": "b70b",
	"./4.png": "a700",
	"./5.png": "ff8d",
	"./6.png": "2c17"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a77c";